import React, { useEffect, useState, useMemo } from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'astroturf/react';
import { Link } from './Link';
import { getWork } from 'js/social/api/work_api';
import { InversePaperIcon as InversePaperIconBase } from '../Icons';
import _InversePaperIcon from "PaperLinkElement-InversePaperIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/PaperLinkElement.tsx?styleId=InversePaperIcon";
import _PaperLink from "PaperLinkElement-PaperLink.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/PaperLinkElement.tsx?styleId=PaperLink";


const InversePaperIcon = /*#__PURE__*/styled(InversePaperIconBase, null, {
  displayName: "InversePaperIcon",
  styles: _InversePaperIcon
});

const PaperLink = /*#__PURE__*/styled(Link, null, {
  displayName: "PaperLink",
  styles: _PaperLink
});

export const PaperLinkElement: React.FC<RenderElementProps> = ({
  attributes,
  element,
  children,
}) => {
  const [paperTitle, setPaperTitle] = useState<string | null>(null);
  const [paperUrl, setPaperUrl] = useState<string>('');

  useEffect(() => {
    async function fetchWorkData() {
      try {
        const paper = await getWork({
          id: element.data.workId,
          slug: '',
        });

        setPaperUrl(paper.url);
        setPaperTitle(paper.title);
      } catch {
        // Reasonable for this to throw a 404. In any case, do nothing.
      }
    }

    fetchWorkData();
  }, [element]);

  const urlFromTypedText = useMemo(() => {
    let typedUrl = element.data.text;
    if (typedUrl.indexOf('http') !== 0) {
      typedUrl = 'https://' + typedUrl;
    }
    try {
      return new URL(typedUrl).href;
    } catch {
      return typedUrl;
    }
  }, [element]);

  if (paperTitle === null) {
    return (
      <PaperLink
        {...(({ ref: _, ...rest }) => rest)(attributes)}
        href={urlFromTypedText}
        contentEditable={false}
      >
        {children}
        {element.data.text}
      </PaperLink>
    );
  }

  return (
    <PaperLink
      {...(({ ref: _, ...rest }) => rest)(attributes)}
      href={paperUrl}
      contentEditable={false}
    >
      {children}
      <InversePaperIcon />
      {paperTitle}
    </PaperLink>
  );
};
